import { render, staticRenderFns } from "./RightMenuItems2.vue?vue&type=template&id=1d60dbd9&scoped=true&"
import script from "./RightMenuItems2.vue?vue&type=script&lang=js&"
export * from "./RightMenuItems2.vue?vue&type=script&lang=js&"
import style0 from "./RightMenuItems2.vue?vue&type=style&index=0&id=1d60dbd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d60dbd9",
  null
  
)

export default component.exports